import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useCustomModels = ({ perPage = 250, page = 1 }: { perPage: number; page: number }) => {
  const { workspaceId } = useParams();
  const authContext = useAuth();

  return useQuery({
    queryKey: ["custom-models", workspaceId, perPage, page],
    queryFn: () => {
      const url = new URL(ENDPOINTS.custom_models(workspaceId!));

      if (perPage) {
        url.searchParams.set("per_page", perPage.toString());
      }

      if (page) {
        url.searchParams.set("page", page.toString());
      }

      return fetch(url.toString(), {
        method: "GET",
        headers: jsonAuthHeaders(authContext?.userToken ?? ""),
      }).then(res => handleResponse(res));
    },
  });
};
